import React from "react";

function Login() {
  return (
    <>
  <div className="d-flex flex-center flex-column flex-lg-row-fluid">
  <img alt="" src="/assets/img/logo-1-dark.svg" className="h-75px mb-12 mt-12" />
  {/*begin::Wrapper*/}
  <div className="w-lg-500px p-10 card">
    {/*begin::Form*/}
    <form className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
      {/*begin::Heading*/}
      <div className="text-center mb-11">
        {/*begin::Title*/}
        <h2 className="text-dark fw-bolder mb-3">Sign In</h2>
        {/*end::Title*/}
        {/*begin::Alert*/}
        {/* ### loginError */}
        <div className="alert alert-danger d-flex align-items-center p-5">
          {/*begin::Icon*/}
          <span className="svg-icon svg-icon-2hx svg-icon-danger me-3">
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.3"
                d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"
                fill="currentColor"
              />
              <path
                d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z"
                fill="currentColor"
              />
            </svg>
          </span>
          {/*end::Icon*/}
          {/*begin::Wrapper*/}
          <div className="d-flex flex-column">
            <span>Invalid login details</span>
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Alert*/}
      </div>
      {/*begin::Heading*/}
      {/*begin::Input group-*/}
      <div className="fv-row mb-8 fv-plugins-icon-container">
        {/*begin::Email*/}
        <input
          type="text"
          placeholder="Username"
          name="username"
          autoComplete="off"
          className="form-control bg-transparent"
        />
        {/*end::Email*/}
        <div className="fv-plugins-message-container invalid-feedback" />
      </div>
      {/*end::Input group-*/}
      <div className="fv-row mb-3 fv-plugins-icon-container">
        {/*begin::Password*/}
        <input
          type="password"
          placeholder="Password"
          name="password"
          autoComplete="off"
          className="form-control bg-transparent"
        />
        {/*end::Password*/}
        <div className="fv-plugins-message-container invalid-feedback" />
      </div>
      {/*end::Input group-*/}
      {/*begin::Submit button*/}
      <div className="d-grid mb-10">
        <button
          type="submit"
          id="kt_sign_in_submit"
          className="btn btn-primary"
          on-click="doSignIn()"
        >
          {/*begin::Indicator label*/}
          {/* ### !signingIn */}
          <span className="indicator-label">Sign In</span>
          {/*end::Indicator label*/}
          {/*begin::Indicator progress*/}
          {/* ### signingIn */}
          <span>
            Please wait...{" "}
            <span className="spinner-border spinner-border-sm align-middle ms-2" />
          </span>
          {/*end::Indicator progress*/}{" "}
        </button>
      </div>
      {/*end::Submit button*/}
    </form>
    {/*end::Form*/}
  </div>
  {/*end::Wrapper*/}
</div>

</>

  );
}

export default Login;
